import type { Vector3 } from '@kitware/vtk.js/types';
import type vtkWidgetState from '@kitware/vtk.js/Widgets/Core/WidgetState';

import type { IBrushStencil } from '@/src/core/tools/paint/brush';

import vtkStateBuilder from '@kitware/vtk.js/Widgets/Core/StateBuilder';

export interface PaintPointWidgetState extends vtkWidgetState {
  setOrigin: (origin: Vector3 | null) => boolean;
  getOrigin: () => Vector3 | null;
  setScale1: (scale: number) => boolean;
  getScale1: () => number;
  setVisible: (visible: boolean) => boolean;
  getVisible: () => boolean;
  setColor: (color: number) => boolean;
  getColor: () => number;
}

export interface PaintWidgetState extends vtkWidgetState {
  getBrush: () => PaintPointWidgetState;
  getStencil: () => IBrushStencil;
  setStencil: (stencil: IBrushStencil) => boolean;
}

export default function generateState() {
  const builder = vtkStateBuilder
    .createBuilder();
  builder.addStateFromMixin({
    labels: ['brush'],
    name: 'brush',
    mixins: ['origin', 'scale1', 'visible', 'color'],
    initialValues: {
      scale1: 1,
      origin: null,
      visible: true,
    },
  });
  builder.addField({
    name: 'stencil',
    initialValue: null,
  });
  return builder.build() as PaintWidgetState;
}
